namespace JupitersChoice {
    export class OuterArrowCustom extends Sapphire.Sprite {

        private _spinTween: TweenMax;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data);
            //this.anchor.set(data.anchor.x, data.anchor.y);
        }

        public spin(degrees: number, duration: number, onComplete: Function) {
            this._spinTween = new TweenMax(this, duration, {
                ease: new Ease(BezierEasing(.25, 1, .93, 1.01), [], 0, 0),
                rotation: degrees * (Math.PI / 180),
                onComplete: () => {
                    onComplete();
                }
            });
        }

        reset(): void {
            this.rotation = 0;
        }
    }
}